import * as React from "react";
import {IPortfolioFeesTreeNode} from "../../api/PortfolioApi";
import {getEllipsePosition} from "./portfolioUtil";
import {useEffect, useRef} from "react";

export interface IFeesPopupProps {
    selectedNode: IPortfolioFeesTreeNode;
    yAxisPosition:  number;
    closePopup: () => void;
}
export const FeesPopup: React.FC<IFeesPopupProps> = (props) => {
    const fundExpenseOffset = 33;
    const popupRef = useRef<HTMLDivElement | null>(null);
    const displayQuartile = props.selectedNode.percentile25 != null && props.selectedNode.percentile75 != null;

    const handleEvent = (event: MouseEvent | KeyboardEvent) => {
        if (
            (event instanceof MouseEvent && popupRef.current && !popupRef.current.contains(event.target as Node)) ||
            (event instanceof KeyboardEvent && event.key === "Escape")
        ) {
            props.closePopup();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleEvent);
        document.addEventListener("keydown", handleEvent);
        return () => {
            document.removeEventListener("mousedown", handleEvent);
            document.removeEventListener("keydown", handleEvent);
        };
    }, []);

    return <div ref={popupRef}
             data-testid={"fees-popup__container"}
             className={"fees-popup__container"}
             id={"fees-popup__container"}
             style={{top: props.yAxisPosition}}>
            <div className={"fees-popup__fund-name"}>
                <div>{props.selectedNode.name}</div>
                <div className={"close-icon fa-regular fa-x"} data-testid={"fees-popup__close-icon"}
                     onClick={() => props.closePopup()}
                />
            </div>
            <div className={"fees-popup__title"}>
                <h5>Peer Universe Fee Range</h5>
            </div>
            <div className={"fees-popup__population"} data-testid={"fees-popup__population"}>
                {props.selectedNode.population
                    && <div>There are {props.selectedNode.population} members in this peer universe</div>}
            </div>
            <div className={"fees-popup__fund-expense"}
                 style={{paddingLeft: `${getEllipsePosition(props.selectedNode) - fundExpenseOffset}px`}}>
                <div className={"fees-popup__fund-expense_title"}>Fund Expense</div>
                <div className={"fees-popup__fund-expense_value"}>
                    {props.selectedNode.effectiveNetExpenseRatio?.toFixed(3)}
                </div>
            </div>
            <div className={"fees-popup__status"}>
                <div className={"fees-popup__gradient-bar"} data-testid={"fees-popup__gradient-bar"}/>
                <div className={"fees-popup__ellipse"}
                     data-testid={"fees-popup__ellipse"}
                     style={{paddingLeft: `${getEllipsePosition(props.selectedNode)}px`}}/>
            </div>
            <div className={"fees-popup__quartile"}>
                <div className={"fees-popup__quartile-container"}>
                    <div className={"quartile"}>
                        {displayQuartile && <div className={"first"}>
                            <div className={"quartile__name"}>1st Quartile</div>
                            <div>{props.selectedNode.percentile25?.toFixed(3)}</div>
                        </div>}
                    </div>
                    <div className={"quartile"}>
                        <div className={"median"}>
                            <div className={"quartile__name"}>Median</div>
                            <div>{props.selectedNode.percentile50?.toFixed(3)}</div>
                        </div>
                    </div>
                    <div className={"quartile"}>
                        {displayQuartile && <div className={"third"}>
                            <div className={"quartile__name"}>3rd Quartile</div>
                            <div>{props.selectedNode.percentile75?.toFixed(3)}</div>
                        </div>}
                    </div>
                </div>
            </div>
    </div>;
};